export { NAVS_SEC, MAP_ALL_ATTRS_SEC }
const MAP_ATTRS_SEC = {
	id:'ATTRS_SEC',
	navLabel:'sidenav.security.label',
	navIcon:'lock',
	instancesClass:{
		role:{
			iconClass: 'unlock-alt',
			attrsList: [
				{attrName: 'authority', attrCol: '40%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '20%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '20%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		rule:{
			iconClass: 'gears',
			attrsList: [
				{attrName: 'name', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'controllerName', attrCol: '15%', searchable: true, sortable: true},
				{attrName: 'actionName', attrCol: '15%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		secright:{
			iconClass: 'check',
			attrsList: [
				{attrName: 'permissions', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'roleLib', attrCol: '20%', searchable: false, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		requestmap:{
			iconClass: 'certificate',
			attrsList: [
				{attrName: 'configAttribute', attrCol: '25%', searchable: true, sortable: true},
				{attrName: 'httpMethod', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'url', attrCol: '25%', searchable: true, sortable: true}
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		user:{
			iconClass: 'users',
			attrsList: [
				{attrName: 'username', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'email', attrCol: '15%', searchable: true, sortable: true},
				{attrName: 'roles', attrCol: '15%', searchable: false, sortable: true, attrImport: true},
				{attrName: 'enabled', attrCol: '15%', searchable: false, sortable: true, attrImport: true},
				{attrName: 'passwordExpiration', attrCol: '15%', searchable: false, sortable: true, attrImport: true}
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		}

	}
}
const NAVS_SEC = [MAP_ATTRS_SEC]

const MAP_ALL_ATTRS_SEC = {};
for (let key in MAP_ATTRS_SEC.instancesClass) {
	MAP_ALL_ATTRS_SEC[key]= MAP_ATTRS_SEC.instancesClass[key]
}